<script lang="ts">
  import {uid} from 'uid';
  import {type TextInputProps} from '.';
  import {BaseInput} from 'Catalyst/components/BaseInput';

  // eslint-disable-next-line no-unused-vars
  type $$Props = TextInputProps;

  export let id: TextInputProps['id'] = uid();
  export let inputTestId: TextInputProps['inputTestId'] = `${id}-text-input`;
  export let labelTestId: TextInputProps['labelTestId'] = 'text-input-label';
  export let value: TextInputProps['value'] = '';
  export let ref: HTMLInputElement = null;
</script>

<BaseInput
  {...$$restProps}
  {id}
  {inputTestId}
  {labelTestId}
  bind:value
  on:blur
  on:click
  on:focus
  on:input
  bind:ref
>
  <slot name="suffix" slot="suffix" />
</BaseInput>
